import {SafeAreaView, View} from 'react-native';

import {isMobile} from 'common/constants';

export const SafeAreaWrapper = isMobile ? SafeAreaView : View;
